import {connect} from 'react-redux'
import {DetailValue, field, modal, utils, Loader, authActions} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import CustomerPage from "./CustomerPage";
import {Alert, Button, Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import ObjednavkaListPanel from "../../components/ObjednavkaListPanel";
import {withRouter} from "react-router";
import {getOrderTimeoutMinutes, redirectToOrderStepNumber} from "../../utils/utils";
import MujUcetPanel from "../../components/MujUcetPanel";
import RozpracovanaObjednavkaModal from "../../components/RozpracovanaObjednavkaModal";
import * as objednavkaActions from "../../actions/objednavkaActions";
import * as opravneniActions from "../../actions/opravneniActions";
import * as subjektActions from "../../actions/subjektActions";
import * as uzivatelActions from "../../actions/uzivatelActions";
import {withTranslation, WithTranslation} from "react-i18next";
import './CustomerHomePage.scss';

/**
 * Homepage zákazníka, zobrazující jeho objednávky, údaje apod.
 */
class CustomerHomePage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        const {loggedInUser, aktivniSpolecnostId} = this.props;
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        if (loggedInUser.fetched && !loggedInUser.isFetching) {
            const loggedInUserId = loggedInUser.data.id;
            this.props.dispatch(uzivatelActions.fetchSpolecnostIdIfNeeded(loggedInUserId));
            this.props.dispatch(subjektActions.fetchUzivatelDetailIfNeeded(loggedInUserId));
            this.props.dispatch(uzivatelActions.fetchSpolecnostiPrihlasenyUzivatelIfNeeded(loggedInUserId));
            this.props.dispatch(objednavkaActions.fetchObjednavkaLastStep(loggedInUserId));
            this.props.dispatch(objednavkaActions.fetchObjednavkaLastFinishedStep(loggedInUserId));
            this.props.dispatch(objednavkaActions.fetchCasRozpracovaniObjednavky(loggedInUserId));
            this.props.dispatch(objednavkaActions.fetchObjednavkyPrehledIfNeeded(loggedInUserId));
            // aktivniSpolecnostId.data tu může být undefined, ale to nevadí
            this.props.dispatch(subjektActions.fetchAktivniAdresyUzivatelIfNeeded(loggedInUserId, aktivniSpolecnostId.data));
        }
    };

    handleFulltextChange = (value) => {
        const {objednavkyPrehledList} = this.props;
        this.props.dispatch(objednavkaActions.filterObjednavkyPrehled({
            ...objednavkyPrehledList.filter,
            fulltext: value
        }));
    };

    handleClearFulltext = () => {
        this.handleFulltextChange("");
    };

    handleZobrazitVse = () => {
        this.props.history.push('/objednavky');
    };

    // TODO berka duplicitní kód na ObjednavkyPage - ideálně někam vytáhnout
    handleNovaObjednavka = () => {
        const {authInfo, loggedInUser, lastSavedStep, lastSavedFinishedStep, casRozpracovaniObjednavky, t} = this.props;

        if (!lastSavedStep.data && !lastSavedFinishedStep.data) { // nemáme rozpracovanou objednávku
            return redirectToOrderStepNumber(1, this.props);
        }
        // máme rozpracovanou objednávku - zkontrolujeme timeout
        const casRozpracovaniSeconds = casRozpracovaniObjednavky.data && Math.floor(casRozpracovaniObjednavky.data / 1000);
        const timeoutMinutes = getOrderTimeoutMinutes(authInfo);
        if (casRozpracovaniSeconds && timeoutMinutes) {
            const currentTimeSeconds = Math.floor(Date.now() / 1000);
            const timeoutSeconds = timeoutMinutes * 60;
            const remaining = (casRozpracovaniSeconds + timeoutSeconds) - currentTimeSeconds;
            if (remaining <= 0) {
                this.props.dispatch(objednavkaActions.clearRozpracovanaObjednavka(loggedInUser.data.id));
                return redirectToOrderStepNumber(1, this.props);
            }
        }
        // objednávka zatím nevypršela - necháme uživatele pokračovat
        this.props.dispatch(
            modal.ModalActions.show(
                RozpracovanaObjednavkaModal,
                {
                    onContinueOrder: () => {
                        this.props.dispatch(modal.ModalActions.hide());
                        const step = lastSavedFinishedStep.data ? lastSavedFinishedStep.data + 1 : lastSavedStep.data;
                        redirectToOrderStepNumber(step, this.props);
                    },
                    onNewOrder: () => {
                        this.props.dispatch(modal.ModalActions.hide());
                        this.props.dispatch(objednavkaActions.clearRozpracovanaObjednavka(loggedInUser.data.id));
                        redirectToOrderStepNumber(1, this.props);
                    },
                },
                t('order.unfinished'),
            )
        );
    };

    render() {
        const {loggedInUser, aktivniSpolecnostId, uzivatelDetail, adresyUzivatelList, spolecnostiUzivatelList,
            objednavkyPrehledList, t} = this.props;

        let objednavkyPrehled;
        if (!objednavkyPrehledList.fetched) {
            objednavkyPrehled = <Loader/>;
        } else if (objednavkyPrehledList.rows.length === 0) {
            objednavkyPrehled = <CardBody><i>{t('order.no_orders')}</i></CardBody>
        } else {
            objednavkyPrehled = <div className="items-list bordered">
                {objednavkyPrehledList.rows.map(objednavka => <ObjednavkaListPanel key={objednavka.id} objednavka={objednavka}/>)}
            </div>;
        }

        const zobrazitVse = <CardBody>
            <a href="#" onClick={this.handleZobrazitVse}><h2>{t('show_all')}</h2></a>
        </CardBody>;

        return <div className="customer-home-page w-100 h-100">
            <CustomerPage title={t('pages.main.title')}>
                <Row>
                    <Col xs={8}>
                        <Card>
                            <CardHeader>
                                <h2>{t('order.many')}</h2>
                            </CardHeader>
                            <CardBody>
                                <div className="stav-objednavek">
                                    <DetailValue label={t('order.state_many')}>
                                        {t('order.create_hint')}
                                    </DetailValue>
                                    <Button color="primary" onClick={this.handleNovaObjednavka}>{t('order.new')}</Button>
                                </div>
                            </CardBody>
                            <CardBody className="p-0">
                                <Card>
                                    <CardHeader className="toolbar">
                                        <Row>
                                            <Col xs={12} md={8}>
                                                <h2>{t('order.last_many')}</h2>
                                            </Col>
                                            <Col xs={12} md={4}>
                                                <field.Search value={objednavkyPrehledList.filter.fulltext} onChange={this.handleFulltextChange} />
                                            </Col>
                                        </Row>
                                    </CardHeader>
                                    {objednavkyPrehledList.filter.fulltext &&
                                    <Alert color="info" isOpen toggle={this.handleClearFulltext}>
                                        {t('order.showing_max', {count: 5, expression: objednavkyPrehledList.filter.fulltext})}
                                    </Alert>}
                                    {objednavkyPrehled}
                                </Card>
                            </CardBody>
                            {zobrazitVse}
                        </Card>
                    </Col>
                    <Col xs={4}>
                        {aktivniSpolecnostId.fetched && uzivatelDetail.fetched && adresyUzivatelList.fetched && spolecnostiUzivatelList.fetched ?
                        <MujUcetPanel aktivniSpolecnostId={aktivniSpolecnostId.data}
                                      uzivatel={uzivatelDetail.data}
                                      adresyUzivatelList={adresyUzivatelList.rows}
                                      spolecnostiUzivatelList={spolecnostiUzivatelList.rows}
                                      externiRezim={loggedInUser.data.extSystemRezim}
                        /> : <Loader/>}
                    </Col>
                </Row>
            </CustomerPage>
        </div>
    }
}

function mapStateToProps(state) {
    return {
        authInfo: utils.storeFromArea(state, authActions.AUTH_INFO_AREA),
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        aktivniSpolecnostId: utils.storeFromArea(state, uzivatelActions.PRIHLASENY_UZIVATEL_SPOLECNOST_ID_DETAIL_AREA),
        uzivatelDetail: utils.storeFromArea(state, subjektActions.UZIVATEL_DETAIL_AREA),
        adresyUzivatelList: utils.storeFromArea(state, subjektActions.UZIVATEL_AKTIVNI_ADRESY_LIST_AREA),
        spolecnostiUzivatelList: utils.storeFromArea(state, uzivatelActions.PRIHLASENY_UZIVATEL_SPOLECNOSTI_LIST_AREA),
        objednavkyPrehledList: utils.storeFromArea(state, objednavkaActions.OBJEDNAVKY_PREHLED_LIST_AREA),
        lastSavedStep: utils.storeFromArea(state, objednavkaActions.LAST_SAVED_STEP_AREA),
        lastSavedFinishedStep: utils.storeFromArea(state, objednavkaActions.LAST_SAVED_FINISHED_STEP_AREA),
        casRozpracovaniObjednavky: utils.storeFromArea(state, objednavkaActions.CAS_ROZPRACOVANI_DETAIL_AREA),
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation()(CustomerHomePage)));
